module.exports = __webpack_public_path__ + "static/media/hall-PALAEXPO.8448127c.svg";